import JSEncrypt from 'jsencrypt';
import { pubKey } from '@/config/config';

/**
 * 全局加密器实例
 */
const encryptor = new JSEncrypt();
encryptor.setPublicKey(pubKey);

/**
 * RSA 加密函数
 * @param data - 需要加密的数据
 * @returns 加密后的字符串，加密失败返回 false
 */
export const encrypt = (data: string): string | false => {
    try {
        return encryptor.encrypt(data);
    } catch {
        return false;
    }
};

/**
 * 获取加密器实例
 * @returns JSEncrypt 实例
 */
export const getEncryptor = (): JSEncrypt => {
    return encryptor;
};

export { encryptor };
export default encrypt;
